import React, { Component } from "react";
import LoginForm from "./LoginForm";

class SignIn extends Component {
  render() {
    const { onSignInSuccess } = this.props;
    return (
      <div>
        <LoginForm onSignInSuccess={onSignInSuccess} handleError={this.props.handleError} />
      </div>
    );
  }
}

export default SignIn;
